export default function getCsrfToken () {
  const ret = $('meta[name="csrf-token"]').attr('content')
  console.log('getCsrfToken', ret)
  return ret
}
